import { removeStorageItem, setStorageItem } from 'utils/ui/storage';
import type { IBrand, IMarket } from 'data/schema';
import { validateDealerSelection } from './dealerResolution';
import type { TDealerSelectionValidation } from './dealerResolution.types';

interface ICommitDealerContext {
  dealerIds: readonly string[];
  brand: IBrand;
  market: IMarket;
}

/**
 * Validates a dealer selection and, only when it is valid, stores it as `auth:dealerId`.
 * Never touches `userSession()`: the selection is fixed for the login and must not reset the session.
 * A rejected selection writes nothing, so a previously committed ID stays in place.
 */
export function commitDealerSelection(dealerId: string, context: ICommitDealerContext): TDealerSelectionValidation {
  const validation = validateDealerSelection(dealerId, context);

  if (validation.ok) {
    setStorageItem('sessionStorage', 'auth:dealerId', dealerId);
  }

  return validation;
}

/** Drops the stored selection (fresh sign-in), so the next login runs the selection step from scratch. */
export function clearDealerSelection(): void {
  removeStorageItem('sessionStorage', 'auth:dealerId');
}
